import { render } from "./Campuses.vue?vue&type=template&id=ebce94b6"
import script from "./Campuses.vue?vue&type=script&lang=js"
export * from "./Campuses.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Campuses/Campuses.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ebce94b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ebce94b6', __exports__)) {
    api.reload('ebce94b6', __exports__)
  }
  
  module.hot.accept("./Campuses.vue?vue&type=template&id=ebce94b6", () => {
    api.rerender('ebce94b6', render)
  })

}


export default __exports__